import KeybeAvatar from '@/shared/infrastructure/ui/KeybeAvatar.vue'
import KeybeIcon from '@/shared/infrastructure/ui/icons/KeybeIcon.vue'
import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'
import { mapState } from 'vuex'
import UserUseCases from '@/modules/Config/GeneralUserConfiguration/application/UserUseCases'
import { dataToUploadImage, userImageUpdater } from '@/modules/Config/GeneralUserConfiguration/domain/UserController'
import UserController from '@/modules/Config/GeneralUserConfiguration/infrastructure/controller/User.controller'
import EmitToast from '@/utils/EmitToast'
export default {
  components: {
    KeybeAvatar,
    KeybeIcon
  },
  props: {
    isUserOnline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('UserStore', ['user', 'token']),
    ...mapState('AppStore', ['selectedApp']),
    userImage (): string {
      return this.user?.photo || ''
    }
  },
  data () {
    return {
      KeybeIconType,
      userController: new UserController()
    }
  },
  methods: {
    openFileInput (): void {
      this.$refs.imageInput.click()
    },
    async onFilePicked (event: any): Promise<void> {
      const img: any = event.target.files[0]
      URL.createObjectURL(img)
      const data: dataToUploadImage = {
        img,
        uuid: this.user?.uuid,
        appId: this.selectedApp?.uuid,
        token: this.token
      }
      const response: userImageUpdater = await UserUseCases.uploadUserImage(this.userController, data)
      if (response.statusCode === 200) EmitToast.emitSuccess(this.$t('profilePicUpdated'))
      else EmitToast.emitErrors(this.$t('errorUpdatingProfilePic'))
    }
  }
}
